import {
  COMMUNITY_COMPASS_REPORT_SAMPLE,
  COMPARATIVE_LOCATION_ANALYSIS_REPORT_SAMPLE,
  FEASIBILITY_STUDY_REPORT_SAMPLE,
  LOCATION_INTELLIGENCE_REPORT_SAMPLE,
  OPEN_HOUSE_FLYER_REPORT_SAMPLE,
  ReportTypes,
} from '../../../../user/user/user.model';

export type ReportData = {
  id: ReportTypes;
  title: string;
  audience: string;
  sample: string;
  description: string;
  features: string[];
  footer: string;
  forInnerUse: boolean;
  priceInfo: {
    freeCount?: number;
    price: string;
  };
};

export const reportData: ReportData[] = [
  {
    id: ReportTypes.COMMUNITY_COMPASS,
    title: 'Community compass',
    audience: '(for homebuyers / realtors)',
    sample: COMMUNITY_COMPASS_REPORT_SAMPLE,
    description: 'Get clear neighborhood insights in a detailed report',
    features: [
      'Neighborhood summary',
      'Real estate',
      'Demographic',
      'Health',
      'Schools',
      'Crime',
      'Entertainment & Convenience',
      'Commute & Mobility',
    ],
    footer: 'Interactive report + PDF file',
    forInnerUse: false,
    priceInfo: {
      price: '$9.95',
    },
  },
  {
    id: ReportTypes.OPEN_HOUSE_FLYER,
    title: 'Open house flyer',
    sample: OPEN_HOUSE_FLYER_REPORT_SAMPLE,
    audience: '(for realtors)',
    description: 'Neighborhood stats presented in a concise two-page flyer',
    features: [
      'Location overview',
      'Demographics',
      'Amenities',
      'Schools',
      'Real estate',
    ],
    footer: 'Interactive report + PDF file',
    forInnerUse: false,
    priceInfo: {
      price: '$7.95',
    },
  },
  {
    id: ReportTypes.LOCATION_INTELLIGENCE,
    sample: LOCATION_INTELLIGENCE_REPORT_SAMPLE,
    title: 'Location intelligence report',
    audience: '(for business)',
    description: 'Comprehensive business report for grounded decision-making',
    features: ['Population', 'Income', 'Trends', 'Environment', 'Competition'],
    footer: 'Interactive report + PDF file:',
    forInnerUse: false,
    priceInfo: {
      price: '$399',
    },
  },
  {
    id: ReportTypes.COMPARATIVE_LOCATION,
    sample: COMPARATIVE_LOCATION_ANALYSIS_REPORT_SAMPLE,
    title: 'Comparative location analysis',
    audience: '(for business)',
    description: 'Compare 2 potential business locations in one report',
    features: ['Population', 'Income', 'Trends', 'Environment', 'Competition'],
    footer: 'Interactive report + PDF file',
    forInnerUse: false,
    priceInfo: {
      price: '$799',
    },
  },
  {
    id: ReportTypes.FEASIBILITY_STUDY,
    sample: FEASIBILITY_STUDY_REPORT_SAMPLE,
    title: 'Feasibility study',
    audience: '',
    description: '',
    features: [''],
    footer: '',
    priceInfo: {
      price: '',
    },
    forInnerUse: true,
  },
];
